import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import axios from 'axios'
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export const axiosPostWrapper = async ({ body, url }: { body: any, url: string }) => {
  try {
    const res = await axios.post(url, body)
    return res.data
  } catch (e) {
    console.log(e)
    throw e
  }
}
export const endStatus = [{
  label: "Pre-Ship",
  value: "Pre Ship"
}, {
  label: "Post-Ship",
  value: "Post Ship"
},
{ label: "Stack start(stacked+30m)", value: "Stack start(stacked+30m)" },
{ label: "Stack Week-1", value: "Stack Week-1" },
{ label: "Stack Week-2", value: "Stack Week-2" },
{ label: "Stack Week-3", value: "Stack Week-3" },
{ label: "Stack Week-4 (unstacking+30M)", value: "Stack Week-4 (unstacking+30M)" }
]


export const getUnit = (value: string) => {
  if (value === 'inch') {
      return 'in'
  }
  else if (value === 'oz') {
      return 'fl oz'
  } else if (value === 'lbs') {
      return 'lb'
  } else {
      return value
  }
}
export function formatDimensions(dimensionString) {
  // Replace '×' with 'x'
  return dimensionString.replace(/×/g, 'x');
}
export function getStringBeforeMaterial(inputString,) {
  const parts = inputString.split(' ', 1);
  return parts[0];
}

export const packagingData = [
  { packagingType: "Shell", materialGSM: 350 },
  { packagingType: "Case", materialGSM: 500 },
  { packagingType: "Paperboard Wrap", materialGSM: 400 },
  { packagingType: "Shrink", materialGSM: 90 },
  { packagingType: "Shrink W Pad", materialGSM: 490 },
  { packagingType: "Shrink W Tray", materialGSM: 590 },
  { packagingType: "TRAY & CASE", materialGSM: 500 },
  { packagingType: "Tray", materialGSM: 500 },
  { packagingType: "Wrap", materialGSM: 350 },
  { packagingType: "PAD", materialGSM: 400 },
  { packagingType: "case/pack", materialGSM: 500 },
  { packagingType: "Base", materialGSM: 500 },
  { packagingType: "CASE/Shell", materialGSM: 500 },
  { packagingType: "Tray -Shrink", materialGSM: 590 },
  { packagingType: "Others", materialGSM: 350 },
  { packagingType: "Corrugated Case", materialGSM: 500 },
  { packagingType: "Paperboard", materialGSM: 400 },
  { packagingType: "RSW +Pad", materialGSM: 490 },
  { packagingType: "RSW", materialGSM: 90 },
];